module.exports = __webpack_public_path__ + "static/media/security.8bddded8.jpg";